// extracted by mini-css-extract-plugin
module.exports = {"input":"index__input___2JF4h","icon":"index__icon___2gu1u"};